import { forwardRef, type ReactNode, type HTMLAttributes } from 'react';
import { useTheme } from '@vitness/theme';
import { Card } from './Card.js';

export interface StatCardProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string | number;
  trend?: string;
  trendUp?: boolean;
  sparkline?: ReactNode;
}

export const StatCard = forwardRef<HTMLDivElement, StatCardProps>(function StatCard(
  { label, value, trend, trendUp, sparkline, style, ...props },
  ref,
) {
  const { density } = useTheme();
  const pad = density === 'tight' ? 12 : 18;

  return (
    <Card ref={ref} padding={pad} style={style} {...props}>
      <div style={{
        fontFamily: 'var(--vn-font-mono)',
        fontSize: 9,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: 'var(--vn-text-muted)',
        marginBottom: 6,
      }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
        <div>
          <div style={{
            fontFamily: 'var(--vn-font-display)',
            fontSize: 24,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
            color: 'var(--vn-text-primary)',
          }}>{value}</div>
          {trend && (
            <div style={{
              fontFamily: 'var(--vn-font-mono)',
              fontSize: 9,
              marginTop: 3,
              color: trendUp ? '#22C55E' : '#EF4444',
            }}>{trendUp ? '↑' : '↓'} {trend}</div>
          )}
        </div>
        {sparkline}
      </div>
    </Card>
  );
});
